<div
  class="container-filter__padding"
  matMenuContent
  (click)="$event.stopPropagation()"
>
  <div class="item-filter">
    <div class="lista">
      <div class="item" *ngFor="let negocio of listaStatusNegocio">
        <mat-checkbox
          color="primary"
          [(ngModel)]="negocio.ativo"
          labelPosition="before"
          (ngModelChange)="
            atualizaFiltroStatusNegocio.emit({
              negocio: negocio.value,
              newValue: $event
            })
          "
        >
          <div style="position: absolute; width: 100%; height: 50%"></div>
          <span class="filter-text">{{ negocio.viewValue }}</span>
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
